/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

import {
  Card,
  CheckBox,
  Col,
  Grid,
  Input,
  Picker,
  Row,
  Text,
  Button,
  Line,
  UnidadeGestoraFields,
  AutoCompleteInput
} from 'components'
import MagnifyingGlassIcon from 'components/Icons/MagnifyingGlass/'
import { buildSetSize, getItemSize, ReportsRow } from 'components/ReportsRow'
import { useDebounce, useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
import { useWindowResize } from 'hooks/useWindowResize'
import { VariableSizeList as List } from 'react-window'
import {
  DateTime,
  IKeyValue,
  IReportsCurrentContratsModel,
  reportsDatabase
} from 'services/database/reportsDatabase'
import { ReportCurrentContractService } from 'services/NGT/reportCurrentContract'
import { UserCsnService } from 'services/Supplier/Users'
import { COLORS, FORMAT, SPACING, FUNCTIONS } from 'utils'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { AxiosResponse } from 'axios'
export interface typeArray {
  id: number
  name: string
  checked: boolean
}

export interface IAutoComplete {
  matriculaContraparte: IKeyValue<string>[]
  matriculaSubstituto: IKeyValue<string>[]
  nomeContraparte: IKeyValue<string>[]
  nomeSubstituto: IKeyValue<string>[]
}

export interface IResponseFilter {
  contrapartes: typeArray[]
  substitutos: typeArray[]
  empresas: typeArray[]
  centros: typeArray[]
  fornecedores: typeArray[]
  subcontratadas: typeArray[]
  tiposCre: typeArray[]
  contratos: typeArray[]
}

export interface checkboxOptions {
  contrapartesIds: number[]
  substitutosIds: number[]
  empresasIds: number[]
  centros: number[]
  fornecedoresIds: number[]
  subcontratadasIds: number[]
}

export interface ReportsCurrentContract {
  visualizar: Function
  setTableData: Function
  toggleErrorModal: Function
  firstGet: boolean
  setFirstGet: React.Dispatch<React.SetStateAction<boolean>>
}

const defaultResponseFilter = {
  centros: [],
  contrapartes: [],
  contratos: [],
  empresas: [],
  fornecedores: [],
  subcontratadas: [],
  substitutos: [],
  tiposCre: []
}

const DEFAULT_RESPONSE_FILTER = {
  contrapartes: [],
  substitutos: [],
  empresas: [],
  centros: [],
  fornecedores: [],
  subcontratadas: [],
  tiposCre: [],
  contratos: []
}

export interface ITrueCheckboxType {
  centrosIds: number[]
  contrapartesIds: number[]
  dataVigencia: DateTime,
  empresasIds: number[]
  flRecorrente: boolean,
  flSocio: boolean,
  flEncerrado: boolean,
  fornecedoresIds: number[],
  matriculaContraparte: string,
  matriculaSubstituto: string,
  nomeCentro: string,
  nomeContraparte: string,
  nomeEmpresa: string,
  nomeFornecedor: string,
  nomeSubcontratada: string,
  nomeSubstituto: string,
  subcontratadasIds: number[],
  substitutosIds: number[],
  tiposCreIds: number[],
  unidadeGestoraId: IOnChangeUnidadeGestora
}

const DEFAULT_SET_TRUE_CHECKBOX = {
  centrosIds: [],
  contrapartesIds: [],
  dataVigencia: null,
  empresasIds: [],
  flRecorrente: null,
  flSocio: null,
  flEncerrado: null,
  fornecedoresIds: [],
  matriculaContraparte: '',
  matriculaSubstituto: '',
  nomeCentro: '',
  nomeContraparte: '',
  nomeEmpresa: '',
  nomeFornecedor: '',
  nomeSubcontratada: '',
  nomeSubstituto: '',
  subcontratadasIds: [],
  substitutosIds: [],
  tiposCreIds: [],
  unidadeGestoraId: null
}

export enum IEnumType {
  'Sem Preenchimento' = 9,
  'Não se Aplica' = 8,
  'Normal' = 7,
  'Sazonal' = 6
}

const ReportsCurrentContract: React.FC<ReportsCurrentContract> = ({
  toggleErrorModal,
  visualizar,
  setTableData,
  firstGet,
  setFirstGet
}) => {

  const { showModal } = useModal()
  const [tabelaContraparte, setTabelaContraparte] = useState([])
  const [tiposCreIds, setTiposCreIds] = useState<number[]>([])
  const [tabelaSubstituto, setTabelaSubstituto] = useState([])
  const [tabelaFornecedor, setTabelaFornecedor] = useState([])
  const [tabelaEmpresa, setTabelaEmpresa] = useState([])
  const [tabelaCentro, setTabelaCentro] = useState([])
  const [tabelaSubcontratadas, setTabelaSubcontratadas] = useState([])
  const [unidadeGestoraID, setUnidadeGestoraID] =
    useState<IOnChangeUnidadeGestora>({} as IOnChangeUnidadeGestora)
  const childRef: any = useRef()
  const [contratos, setContratos] = useState<typeArray[]>([])
  const { setLoading } = useLoading()
  const [responseFilter, setResponseFilter] = useState<IResponseFilter>(DEFAULT_RESPONSE_FILTER)
  const [trueCheckbox, setTrueCheckbox] = useState<ITrueCheckboxType>(
    DEFAULT_SET_TRUE_CHECKBOX
  )
  const [filterNomeContraparte, setFilterNomeContraparte] = useState({
    nomeContraparte: ''
  })
  const [filterDataVigencia, setFilterDataVigencia] = useState(null)
  const [filterMatriculaContraparte, setMatriculaContraparte] = useState({
    matriculaContraparte: ''
  })
  const [filterNomeSubstituto, setFilterNomeSubstituto] = useState({
    nomeSubstituto: ''
  })
  const [filterMatriculaSubstituto, setMatriculaSubstituto] = useState({
    matriculaSubstituto: ''
  })
  const [filterFornecedor, setFornecedor] = useState({
    nomeFornecedor: ''
  })
  const [filterEmpresa, setEmpresa] = useState({
    nomeEmpresa: ''
  })
  const [filterSubcontratada, setSubcontratada] = useState({
    nomeSubcontratada: ''
  })
  const [filterCentro, setCentro] = useState({
    nomeCentro: ''
  })
  const [filterSocio, setFilterSocio] = useState(null)
  const [filterRecorrente, setFilterRecorrente] = useState(null)
  const [filterEncerrado, setFilterEncerrado] = useState(null)
  const [marcarTodosContraparte, setMarcarTodosContraparte] = useState(false)
  const [marcarTodosSubstituto, setMarcarTodosSubstituto] = useState(false)
  const [marcarTodosFornecedor, setMarcarTodosFornecedor] = useState(false)
  const [marcarTodosEmpresa, setMarcarTodosEmpresa] = useState(false)
  const [marcarTodosCentro, setMarcarTodosCentro] = useState(false)
  const [marcarTodosSubscotratada, setMarcarTodosSubcontratada] =
    useState(false)

  const [autocomplete, setAutocomplete] = useState<IAutoComplete>({
    matriculaContraparte: [],
    matriculaSubstituto: [],
    nomeContraparte: [],
    nomeSubstituto: []
  })

  const [firstGetUnidade, setFirstGetUnidade] = useState(true)

  const { listen: historyListen } = useHistory()

  const historyListenerRef = useRef<() => void | null>(null)
  const REPORTS_PATHS = ['/ngt/relatorios-contratos-vigentes']

  useEffect(() => {
    historyListenerRef.current = historyListen((location) => {
      if (!REPORTS_PATHS.includes(location.pathname)) {
        reportsDatabase.currentContracts.delete(1).then(() => {
          historyListenerRef?.current()
        })
      }
    })
  }, [])

  useEffect(() => {
    setLoading('loading')
    reportsDatabase.currentContracts
      .where({ id: 1 })
      .first()
      .then((currentContract) => {
        if (currentContract) {
          setResponseFilter((oldstate) => ({
            ...oldstate,
            centros: currentContract.centros.map((centro) => ({
              checked: centro.checked || false,
              id: centro.key,
              name: centro.value
            })),
            contrapartes: currentContract.contrapartes.map((contraparte) => ({
              checked: contraparte.checked || false,
              id: contraparte.key,
              name: contraparte.value
            })),
            contratos: currentContract.contratos?.map((contrato) => ({
              checked: contrato.checked || false,
              id: contrato.key,
              name: contrato.value
            })),
            empresas: currentContract.empresas.map((empresa) => ({
              checked: empresa.checked || false,
              id: empresa.key,
              name: empresa.value
            })),
            fornecedores: currentContract.fornecedores.map((fornecedor) => ({
              checked: fornecedor.checked || false,
              id: fornecedor.key,
              name: fornecedor.value
            })),
            subcontratadas: currentContract.subcontratadas.map(
              (subcontratada) => ({
                checked: subcontratada.checked || false,
                id: subcontratada.key,
                name: subcontratada.value
              })
            ),
            substitutos: currentContract.substitutos.map((substituto) => ({
              checked: substituto.checked || false,
              id: substituto.key,
              name: substituto.value
            })),
            tiposCre: currentContract.tipoCres.map((tipoCre) => ({
              checked: tipoCre.checked || false,
              id: tipoCre.key,
              name: tipoCre.value
            }))
          }))

          setMatriculaContraparte({
            matriculaContraparte: currentContract.matriculaContraparte
          })
          setFilterNomeContraparte({
            nomeContraparte: currentContract.nomeContraparte
          })
          setMatriculaSubstituto({
            matriculaSubstituto: currentContract.matriculaSubstituto
          })
          setFilterNomeSubstituto({
            nomeSubstituto: currentContract.nomeSubstituto
          })
          setFornecedor({ nomeFornecedor: currentContract.nomeFornecedor })
          setEmpresa({ nomeEmpresa: currentContract.nomeEmpresa })
          setCentro({ nomeCentro: currentContract.nomeCentro })
          setSubcontratada({
            nomeSubcontratada: currentContract.nomeSubcontratada
          })

          setFilterDataVigencia(
            moment(currentContract?.dataVigencia).isValid()
              ? moment(currentContract?.dataVigencia)
              : null
          )

          setFilterRecorrente(currentContract.flags.recorrente)
          setFilterSocio(currentContract.flags.socio)
          setFilterSocio(currentContract.flags.encerrado)

          setTabelaEmpresa(
            currentContract.empresas.map((empresa) => ({
              id: empresa.key,
              name: empresa.value
            }))
          )
          setContratos(
            currentContract.contratos?.map((contrato) => ({
              checked: contrato.checked,
              id: contrato.key,
              name: contrato.value
            }))
          )
          setTabelaContraparte(
            currentContract.contrapartes.map((empresa) => ({
              id: empresa.key,
              name: empresa.value
            }))
          )
          setTabelaCentro(
            currentContract.centros.map((empresa) => ({
              id: empresa.key,
              name: empresa.value
            }))
          )
          setTabelaFornecedor(
            currentContract.fornecedores.map((empresa) => ({
              id: empresa.key,
              name: empresa.value
            }))
          )
          setTabelaSubstituto(
            currentContract.substitutos.map((empresa) => ({
              id: empresa.key,
              name: empresa.value
            }))
          )
          setTabelaSubcontratadas(
            currentContract.subcontratadas.map((empresa) => ({
              id: empresa.key,
              name: empresa.value
            }))
          )

          // setUnidadeGestoraID(currentContract.unidadeGestoraId)
          setTrueCheckbox((oldState) => ({
            ...oldState,
            flSocio: currentContract.flags.socio,
            flRecorrente: currentContract.flags.recorrente,
            flEncerrado: currentContract.flags.encerrado,
            matriculaContraparte: currentContract.matriculaContraparte,
            matriculaSubstituto: currentContract.matriculaSubstituto,
            nomeCentro: currentContract.nomeCentro,
            nomeContraparte: currentContract.nomeContraparte,
            nomeEmpresa: currentContract.nomeEmpresa,
            nomeFornecedor: currentContract.nomeFornecedor,
            nomeSubcontratada: currentContract.nomeSubcontratada,
            nomeSubstituto: currentContract.nomeSubstituto,
            centrosIds: currentContract.centros
              .filter((value) => value.checked)
              .map((value) => value.key),
            contrapartesIds: currentContract.contrapartes
              .filter((value) => value.checked)
              .map((value) => value.key),
            dataVigencia: moment(currentContract?.dataVigencia).isValid()
              ? moment(currentContract?.dataVigencia)
              : null,
            empresasIds: currentContract.empresas
              .filter((value) => value.checked)
              .map((value) => value.key),
            fornecedoresIds: currentContract.fornecedores
              .filter((value) => value.checked)
              .map((value) => value.key),
            subcontratadasIds: currentContract.subcontratadas
              .filter((value) => value.checked)
              .map((value) => value.key),
            substitutosIds: currentContract.substitutos
              .filter((value) => value.checked)
              .map((value) => value.key),
            tiposCreIds: currentContract.tipoCres
              .filter((value) => value.checked)
              .map((value) => value.key),
            unidadeGestoraId: currentContract.unidadeGestoraId
          }))

          setTiposCreIds(currentContract.tipoCres
            .filter((value) => value.checked)
            .map((value) => value.key))
        }
      })
      .finally(() => setLoading('idle'))
  }, [])

  const buildArray = (array): ITrueCheckboxType => {
    const newArray = {} as ITrueCheckboxType
    if (array.matriculaContraparte) {
      newArray['matriculaContraparte'] = array.matriculaContraparte
    }

    if (array.nomeContraparte) {
      newArray['nomeContraparte'] = array.nomeContraparte
    }

    if (array.matriculaSubstituto) {
      newArray['matriculaSubstituto'] = array.matriculaSubstituto
    }

    if (array.nomeSubstituto) {
      newArray['nomeSubstituto'] = array.nomeSubstituto
    }

    if (filterEmpresa.nomeEmpresa) {
      newArray['nomeEmpresa'] = filterEmpresa.nomeEmpresa
    }

    if (filterSubcontratada.nomeSubcontratada) {
      newArray['nomeSubcontratada'] = filterSubcontratada.nomeSubcontratada
    }

    if (filterCentro.nomeCentro) {
      newArray['nomeCentro'] = filterCentro.nomeCentro
    }

    if (filterFornecedor.nomeFornecedor) {
      newArray['nomeFornecedor'] = filterFornecedor.nomeFornecedor
    }

    if (array.dataVigencia) {
      newArray['dataVigencia'] = array.dataVigencia
    }
    if (array.unidadeGestoraId) {
      newArray['unidadeGestoraId'] = array.unidadeGestoraId
    } else {
      newArray['unidadeGestoraId'] = {
        Diretoria: null,
        DiretoriaExecutiva: null,
        Gerencia: null,
        GerenciaGeral: null
      }
    }
    if (array.flRecorrente) {
      newArray['flRecorrente'] = array.flRecorrente
    }
    if (array.flSocio) {
      newArray['flSocio'] = array.flSocio
    }
    if (array.flSocio) {
      newArray['flEncerrado'] = array.flEncerrado
    }
    if (array.contrapartesIds.length > 0) {
      newArray['contrapartesIds'] = array.contrapartesIds
    }
    if (array.substitutosIds.length > 0) {
      newArray['substitutosIds'] = array.substitutosIds
    }
    if (array.empresasIds.length > 0) {
      newArray['empresasIds'] = array.empresasIds
    }
    if (array.centrosIds.length > 0) {
      newArray['centrosIds'] = array.centrosIds
    }
    if (array.fornecedoresIds.length > 0) {
      newArray['fornecedoresIds'] = array.fornecedoresIds
    }
    if (array.subcontratadasIds.length > 0) {
      newArray['subcontratadasIds'] = array.subcontratadasIds
    }
    if (array.tiposCreIds.length > 0) {
      newArray['tiposCreIds'] = array.tiposCreIds
    }
    return newArray
  }

  const limparTudo = async () => {
    setLoading('loading')

    await reportsDatabase.currentContracts
      .delete(1)
      .then(() => {
        setFirstGetUnidade(true)
        setFirstGet(true)
      }).finally(async () => {
        setTrueCheckbox((prevState) => ({ ...prevState, tiposCreIds: [] }))
        await clearState()
      })
  }

  const clearState = async () => {
    setContratos([])
    limparTudoCamposFiltro()
    setTabelaContraparte([])
    setTabelaSubstituto([])
    setTabelaCentro([])
    setTabelaEmpresa([])
    setTabelaSubcontratadas([])
    setTabelaFornecedor([])
    setMarcarTodosContraparte(false)
    setMarcarTodosSubstituto(false)
    setMarcarTodosEmpresa(false)
    setMarcarTodosCentro(false)
    setMarcarTodosFornecedor(false)
    setMarcarTodosSubcontratada(false)
    setFilterSocio(null)
    setFilterRecorrente(null)
    setFilterEncerrado(null)
    setAutocomplete({
      matriculaContraparte: [],
      matriculaSubstituto: [],
      nomeContraparte: [],
      nomeSubstituto: []
    })
    childRef.current.clearForm()
    setUnidadeGestoraID({} as IOnChangeUnidadeGestora)
    handleDeleteTrueCheckbox();
    setLoading('idle')

  }

  const limparTudoCamposFiltro = () => {
    setFilterNomeContraparte({
      nomeContraparte: ''
    })
    setFilterNomeSubstituto({
      nomeSubstituto: ''
    })
    setFilterDataVigencia(null)
    setMatriculaSubstituto({
      matriculaSubstituto: ''
    })
    setMatriculaContraparte({
      matriculaContraparte: ''
    })
    setFornecedor({
      nomeFornecedor: ''
    })
    setEmpresa({
      nomeEmpresa: ''
    })
    setCentro({
      nomeCentro: ''
    })
  }

  const handleCheckedAll = (name, nameData, tabela) => {
    const copyCheckboxTrue = trueCheckbox
    const checkIds = tabela.map((ids) => ids.id)
    if (responseFilter[nameData]) {
      JSON.stringify(copyCheckboxTrue[name].sort()) ===
        JSON.stringify(checkIds.sort())
        ? (copyCheckboxTrue[name] = [])
        : (copyCheckboxTrue[name] = checkIds)
    }
    const newArray = buildArray(copyCheckboxTrue)
    setTrueCheckbox(copyCheckboxTrue)
    handleFilter(newArray, 'noTable', false)
  }

  const handleCheckFilters = (name, value, table) => {
    const copyCheckboxTrue = trueCheckbox;
    copyCheckboxTrue[name] = value
    const newArray = buildArray(copyCheckboxTrue)
    setTrueCheckbox(copyCheckboxTrue)
    handleFilter(newArray, table, false)
  }

  const handleDeleteTrueCheckbox = () => {
    const copyToDeleteResponseFilter = defaultResponseFilter;
    setTrueCheckbox((prev) => ({ ...prev, tiposCreIds: [] }));
    setResponseFilter(copyToDeleteResponseFilter)
    setTiposCreIds([])
  }

  const handleCheckBox = (
    name,
    value,
    table,
    secondName = null,
    secondValue = null
  ) => {
    const copyCheckboxTrue = trueCheckbox
    let isChecking = false
    // Seta array de id

    if (name == 'tiposCreIds') {
      if (copyCheckboxTrue.tiposCreIds.includes(value)) {
        copyCheckboxTrue.tiposCreIds = copyCheckboxTrue.tiposCreIds.filter(
          (tipo) => tipo !== value
        )
        const newArray = buildArray(copyCheckboxTrue)

        setTiposCreIds((prevState) =>
          prevState.filter((tipo) => tipo !== value)
        )
        setTrueCheckbox(copyCheckboxTrue)
        handleFilter(newArray, table, false, isChecking)
        return
      } else {
        copyCheckboxTrue.tiposCreIds = [...copyCheckboxTrue.tiposCreIds, value]
        setTiposCreIds((prevState) => [...prevState, value])

        const newArray = buildArray(copyCheckboxTrue)

        setTrueCheckbox(copyCheckboxTrue)
        handleFilter(newArray, table, false, isChecking)
        return
      }
    }

    if (Array.isArray(copyCheckboxTrue[name])) {
      if (copyCheckboxTrue[name].includes(value)) {
        copyCheckboxTrue[name].splice(copyCheckboxTrue[name].indexOf(value), 1)
        isChecking = false
      } else {
        copyCheckboxTrue[name].push(value)
        isChecking = true
      }
    } else {
      // Seta input
      copyCheckboxTrue[name] = value
      if (secondName) copyCheckboxTrue[secondName] = secondValue
    }

    const newArray = buildArray(copyCheckboxTrue)

    setTrueCheckbox(copyCheckboxTrue)
    handleFilter(newArray, table, false, isChecking)
  }

  const verifyCheckAll = (response) => {
    JSON.stringify(response.data.contrapartes.sort().map((id) => id.id)) ===
      JSON.stringify(tabelaContraparte?.sort().map((id) => id.id)) &&
      response.data.contrapartes &&
      response.data.contrapartes.length > 0 &&
      !response.data.contrapartes
        ?.sort()
        .map((contraparte) => contraparte.checked)
        .includes(false)
      ? setMarcarTodosContraparte(true)
      : setMarcarTodosContraparte(false)

    JSON.stringify(response.data.substituto?.sort().map((id) => id.id)) ===
      JSON.stringify(tabelaSubstituto?.sort().map((id) => id.id)) &&
      response.data.substituto &&
      response.data.substituto.length > 0 &&
      !response.data.substituto
        ?.sort()
        .map((substituto) => substituto.checked)
        .includes(false)
      ? setMarcarTodosSubstituto(true)
      : setMarcarTodosSubstituto(false)

    JSON.stringify(response.data.centros?.sort().map((id) => id.id)) ===
      JSON.stringify(tabelaCentro?.sort().map((id) => id.id)) &&
      response.data.centros &&
      response.data.centros.length > 0 &&
      !response.data.centros
        ?.sort()
        .map((centros) => centros.checked)
        .includes(false)
      ? setMarcarTodosSubstituto(true)
      : setMarcarTodosSubstituto(false)

    JSON.stringify(response.data.empresas?.sort().map((id) => id.id)) ===
      JSON.stringify(tabelaEmpresa?.sort().map((id) => id.id)) &&
      response.data.empresas &&
      response.data.empresas.length > 0 &&
      !response.data.empresas
        ?.sort()
        .map((empresas) => empresas.checked)
        .includes(false)
      ? setMarcarTodosEmpresa(true)
      : setMarcarTodosEmpresa(false)

    JSON.stringify(response.data.subcontratadas?.sort().map((id) => id.id)) ===
      JSON.stringify(tabelaSubcontratadas?.sort().map((id) => id.id)) &&
      response.data.subcontratadas &&
      response.data.subcontratadas.length > 0 &&
      !response.data.subcontratadas
        ?.sort()
        .map((subcontratadas) => subcontratadas.checked)
        .includes(false)
      ? setMarcarTodosSubcontratada(true)
      : setMarcarTodosSubcontratada(false)

    JSON.stringify(response.data.fornecedores?.sort().map((id) => id.id)) ===
      JSON.stringify(tabelaFornecedor?.sort().map((id) => id.id)) &&
      response.data.fornecedores &&
      response.data.fornecedores.length > 0 &&
      !response.data.fornecedores
        ?.sort()
        .map((fornecedor) => fornecedor.checked)
        .includes(false)
      ? setMarcarTodosFornecedor(true)
      : setMarcarTodosFornecedor(false)
  }

  const atualizarTabelasExceto = (exceto, data, isChecking) => {
    // Listas
    const tabelas = {
      centro: ['centros', setTabelaCentro, trueCheckbox.centrosIds || []],
      contraparte: [
        'contrapartes',
        setTabelaContraparte,
        trueCheckbox.contrapartesIds || []
      ],
      empresa: ['empresas', setTabelaEmpresa, trueCheckbox.empresasIds || []],
      fornecedor: [
        'fornecedores',
        setTabelaFornecedor,
        trueCheckbox.fornecedoresIds || []
      ],
      subcontratada: [
        'subcontratadas',
        setTabelaSubcontratadas,
        trueCheckbox.subcontratadasIds || []
      ],
      substituto: [
        'substitutos',
        setTabelaSubstituto,
        trueCheckbox.substitutosIds || []
      ]
    }

    Object.keys(tabelas).forEach((key) => {
      // Prop especifica com a response
      const propNoBackend = tabelas[key][0]
      // setState da tabela especifica
      const setState = tabelas[key][1]
      const tabela = tabelas[key][2]
      // Se não for a exceção ou não estar checando, atualiza a lista
      if (key !== exceto || (isChecking === false && tabela.length === 0)) {
        // Seta o estado da tabela com a response da prop dela no backend
        setState(data[propNoBackend])
      }
    })
  }

  const handleFilter = (
    prop = trueCheckbox,
    name,
    search,
    isChecking = false
  ) => {
    setLoading('loading')
    ReportCurrentContractService()
      .getFillCards(prop || DEFAULT_SET_TRUE_CHECKBOX)
      .then((response: AxiosResponse<IResponseFilter>) => {
        verifyCheckAll(response)
        // Código novo, desmarcar um filtro traz as opções de volta
        atualizarTabelasExceto(name, response.data, isChecking)

        setResponseFilter(response?.data)
        search ? null : setContratos(response.data.contratos)
        setFirstGet(false)
        setLoading('idle')
      })
      .catch(() => {
        limparTudo()
        // toggleErrorModal()
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }
  const getIds = (array: typeArray[]): number[] =>
    array.flatMap((obj) => (obj.checked ? obj.id : []))

  const handleViewReport = () => {
    const tipoCresExistentes = getIds(responseFilter.tiposCre).filter((id) => !trueCheckbox.tiposCreIds.includes(id))

    const payload = {
      ...FORMAT.propIfExists({
        centrosIds: getIds(responseFilter.centros),
        contrapartesIds: getIds(responseFilter.contrapartes),
        empresasIds: getIds(responseFilter.empresas),
        fornecedoresIds: getIds(responseFilter.fornecedores),
        subcontratadasIds: getIds(responseFilter.subcontratadas),
        substitutosIds: getIds(responseFilter.substitutos),
        tiposCreIds: trueCheckbox?.tiposCreIds?.concat(tipoCresExistentes)
      }),
      ...(moment(filterDataVigencia).isValid() && {
        ...FORMAT.dateIfExists({ dataVigencia: filterDataVigencia })
      }),
      ...(filterRecorrente !== null && { flRecorrente: filterRecorrente }),
      ...(filterSocio !== null && { flSocio: filterSocio }),
      ...(filterEncerrado !== null && { flEncerrado: filterEncerrado }),
      pageNumber: 0,
      pageSize: 15,
      unidadeGestoraId: unidadeGestoraID
    }
    handleSaveFilters()
    setTableData(payload)
    visualizar(true)
  }

  const handleSearchMatricula = (event) => {
    setLoading('loading')
    UserCsnService()
      .getByMatricula(event.target.value)
      .then((response) => {
        const matriculas = response.data.map((matricula) => ({
          label: matricula.nmMatricula,
          value: matricula
        }))
        setAutocomplete((prevState) => ({
          ...prevState,
          [event.target.name]: matriculas
        }))
        setLoading('idle')
      })
      .catch((_) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const getTipoCreValue = (id: number): string => {
    switch (id) {
      case IEnumType.Normal:
        return "Normal"
      case IEnumType.Sazonal:
        return "Sazonal"
      case IEnumType['Sem Preenchimento']:
        return 'Sem Preenchimento'
      case IEnumType['Não se Aplica']:
        return 'Não se Aplica'
      default:
        return '';
    }
  }

  const handleSaveFilters = () => {
    const trueCheckboxItens = trueCheckbox.tiposCreIds.map((tipoCre) => ({
      checked: true,
      key: tipoCre,
      value: getTipoCreValue(tipoCre)
    }))

    const responseFilterItens = responseFilter.tiposCre.map((fillCre) => ({
      checked: true,
      key: fillCre.id,
      value: fillCre.name
    }));

    const itensExistentes = trueCheckboxItens.filter((itens) => !getIds(responseFilter?.tiposCre)?.includes(itens.key))

    responseFilterItens.concat(itensExistentes);

    const newChanges: IReportsCurrentContratsModel = {
      nomeFornecedor: filterFornecedor.nomeFornecedor,
      nomeEmpresa: filterEmpresa.nomeEmpresa,
      nomeContraparte: filterNomeContraparte.nomeContraparte,
      nomeSubcontratada: filterSubcontratada.nomeSubcontratada,
      nomeCentro: filterCentro.nomeCentro,
      matriculaContraparte: filterMatriculaContraparte.matriculaContraparte,
      matriculaSubstituto: filterMatriculaSubstituto.matriculaSubstituto,
      nomeSubstituto: filterNomeSubstituto.nomeSubstituto,
      centros: responseFilter.centros.map((centro) => ({
        checked: trueCheckbox.centrosIds.includes(centro.id),
        key: centro.id,
        value: centro.name
      })),
      contrapartes: responseFilter.contrapartes.map((contraparte) => ({
        checked: trueCheckbox.contrapartesIds.includes(contraparte.id),
        key: contraparte.id,
        value: contraparte.name
      })),
      contratos: responseFilter.contratos?.map((contrato) => ({
        key: contrato.id,
        value: contrato.name
      })),
      dataVigencia: moment(trueCheckbox.dataVigencia)?.toDate(),
      empresas: responseFilter.empresas.map((empresa) => ({
        checked: trueCheckbox.empresasIds.includes(empresa.id),
        key: empresa.id,
        value: empresa.name
      })),
      flags: {
        naoSeAplica: true,
        normal: true,
        recorrente: filterRecorrente,
        sazonal: true,
        semPreenchimento: true,
        socio: filterSocio,
        encerrado: filterEncerrado
      },
      fornecedores: responseFilter.fornecedores.map((fornecedor) => ({
        checked: trueCheckbox.fornecedoresIds.includes(fornecedor.id),
        key: fornecedor.id,
        value: fornecedor.name
      })),
      id: 1,
      subcontratadas: responseFilter.subcontratadas.map((subcontratada) => ({
        checked: trueCheckbox.subcontratadasIds.includes(subcontratada.id),
        key: subcontratada.id,
        value: subcontratada.name
      })),
      substitutos: responseFilter.substitutos.map((substituto) => ({
        checked: trueCheckbox.substitutosIds.includes(substituto.id),
        key: substituto.id,
        value: substituto.name
      })),
      tipoCres: responseFilterItens,
      unidadeGestoraId: unidadeGestoraID
    }

    reportsDatabase.currentContracts
      .where({ id: 1 })
      .first()
      .then((existsReport) => {
        if (existsReport) {
          reportsDatabase.currentContracts.update(1, newChanges)
        } else {
          reportsDatabase.currentContracts.add(newChanges)
        }
      })
  }

  const handleSearchUsuario = (event) => {
    const nmPesquisar = event.target.value;

    if (nmPesquisar.trim() !== "" && nmPesquisar.length >= 3) {
      setTimeout(() => {
        setAutocomplete((prevState) => ({
          ...prevState,
          nomeContraparte: []
        }))

        const valueWithoutLike = nmPesquisar.replaceAll('%', '') as string;
        if (valueWithoutLike === '')
          return setAutocomplete((prevState) => ({
            ...prevState,
            nomeContraparte: [],
            nomeSubstituto: []
          }))
        const isUsingLike = event?.target?.value?.includes('%')
        const valorTratado = isUsingLike
          ? nmPesquisar.replaceAll('%', '%25')
          : nmPesquisar
        setLoading('loading')
        UserCsnService()
          .getByNome(valorTratado, isUsingLike)
          .then((response) => {
            const usuarios = response.data.map((usuario) => ({
              label: usuario.usuario.nmUsuario,
              value: usuario
            }))
            usuarios.sort((usuario, b) => {
              const nmFiltroPesquisa = usuario.label.toUpperCase().split(/ /);

              if (valueWithoutLike.toUpperCase() === nmFiltroPesquisa[0].toUpperCase()) return -1;

              return 0;
            });
            setAutocomplete((prevState) => ({
              ...prevState,
              [event.target.name]: usuarios
            }))
            setLoading('idle')
          })
          .catch((_) => {
            setLoading('idle')
            // toggleErrorModal()
            showModal({
              hideButtonCancel: true,
              message: 'Não foi possivel obter o dados da pesquisa',
              txtButtonConfirm: 'Fechar',
              type: 'error'
            })
          })
      }, 300);
    }
  }

  const contraparteSizeMap = useRef({})
  const contraparteListRef = useRef(null)
  const contraparteSetSize = buildSetSize(
    contraparteSizeMap,
    contraparteListRef
  )

  const fornecedorSizeMap = useRef({})
  const fornecedorListRef = useRef(null)
  const fornecedorSetSize = buildSetSize(fornecedorSizeMap, fornecedorListRef)

  const substitutoSizeMap = useRef({})
  const substitutoListRef = useRef(null)
  const substitutoSetSize = buildSetSize(substitutoSizeMap, substitutoListRef)

  const empresaSizeMap = useRef({})
  const empresaListRef = useRef(null)
  const empresaSetSize = buildSetSize(empresaSizeMap, empresaListRef)

  const centroSizeMap = useRef({})
  const centroListRef = useRef(null)
  const centroSetSize = buildSetSize(centroSizeMap, centroListRef)

  const subcontratadasSizeMap = useRef({})
  const subcontratadasListRef = useRef(null)
  const subcontratadasSetSize = buildSetSize(
    subcontratadasSizeMap,
    subcontratadasListRef
  )

  const [windowWidth] = useWindowResize()

  useEffect(() => {
    if (firstGet && trueCheckbox.contrapartesIds.length > 0) {
      setTrueCheckbox((prevState) => ({ ...prevState, contrapartesIds: [] }))
    }
    if (firstGet && trueCheckbox.substitutosIds.length > 0) {
      setTrueCheckbox((prevState) => ({ ...prevState, substitutosIds: [] }))
    }
    if (firstGet && trueCheckbox.fornecedoresIds.length > 0) {
      setTrueCheckbox((prevState) => ({ ...prevState, fornecedoresIds: [] }))
    }
    if (firstGet && trueCheckbox.empresasIds.length > 0) {
      setTrueCheckbox((prevState) => ({ ...prevState, empresasIds: [] }))
    }
    if (firstGet && trueCheckbox.centrosIds.length > 0) {
      setTrueCheckbox((prevState) => ({ ...prevState, centrosIds: [] }))
    }
    if (firstGet && trueCheckbox.subcontratadasIds.length > 0) {
      setTrueCheckbox((prevState) => ({ ...prevState, subcontratadasIds: [] }))
    }
    // if (firstGet && trueCheckbox.tiposCreIds.length > 0) {
    //   setTrueCheckbox((prevState) => ({ ...prevState, tiposCreIds: [] }))
    // }
  }, [
    trueCheckbox.contrapartesIds,
    trueCheckbox.substitutosIds,
    trueCheckbox.fornecedoresIds,
    trueCheckbox.empresasIds,
    trueCheckbox.centrosIds,
    trueCheckbox.subcontratadasIds
  ])

  return (
    <Card
      marginTop={SPACING.spacing20}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Picker
          value={filterDataVigencia}
          allowTyping={true}
          onChange={(e) => {
            if (!e) {
              setFilterDataVigencia(null)
              handleCheckBox('dataVigencia', null, 'noTable')
              return
            }

            if (moment(e).isValid()) {
              setFilterDataVigencia(e)
              handleCheckBox(
                'dataVigencia',
                FORMAT.formatYYYYMMDD2(e),
                'noTable'
              )
            }
          }}
          label="Data vigência maior que"
        />
      </Grid>
      <Grid gridCols="1fr 1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <AutoCompleteInput
          name="matriculaContraparte"
          marginTop={SPACING.spacing5}
          onChangeText={useDebounce(handleSearchMatricula, 500)}
          value={filterMatriculaContraparte?.matriculaContraparte || null}
          options={autocomplete?.matriculaContraparte || []}
          optionValue="label"
          label="Matrícula contraparte"
          onChange={(_, value) => {
            setMatriculaContraparte({
              matriculaContraparte: value?.nmMatricula || ''
            })
            setFilterNomeContraparte({
              nomeContraparte: value?.usuario?.nmUsuario || ''
            })
            // handleCheckBox('contraparte', value, "noTable")
            handleCheckBox(
              'matriculaContraparte',
              value?.nmMatricula,
              'noTable',
              'nomeContraparte',
              value?.usuario?.nmUsuario
            )
          }}
          valueName="value"
          maxLength={100}
        />

        <AutoCompleteInput
          noFilter
          marginTop={SPACING.spacing5}
          name="nomeContraparte"
          onChangeText={useDebounce(handleSearchUsuario, 600)}
          value={filterNomeContraparte?.nomeContraparte || null}
          options={autocomplete.nomeContraparte || []}
          optionValue="label"
          label="Contraparte"
          onChange={(_, value) => {
            setFilterNomeContraparte({
              nomeContraparte: value?.usuario?.nmUsuario || ''
            })
            setMatriculaContraparte({
              matriculaContraparte: value?.nmMatricula || ''
            })
            handleCheckBox(
              'matriculaContraparte',
              value?.nmMatricula,
              'noTable',
              'nomeContraparte',
              value?.usuario?.nmUsuario
            )
          }}
          valueName="value"
          maxLength={100}
        />

        <AutoCompleteInput
          marginTop={SPACING.spacing5}
          name="matriculaSubstituto"
          onChangeText={useDebounce(handleSearchMatricula, 500)}
          value={filterMatriculaSubstituto?.matriculaSubstituto || null}
          options={autocomplete.matriculaSubstituto || []}
          optionValue="label"
          label="Matrícula substituto"
          onChange={(_, value) => {
            setMatriculaSubstituto({
              matriculaSubstituto: value?.nmMatricula || ''
            })
            setFilterNomeSubstituto({
              nomeSubstituto: value?.usuario?.nmUsuario || ''
            })
            handleCheckBox(
              'matriculaSubstituto',
              value?.nmMatricula,
              'noTable',
              'nomeSubstituto',
              value?.usuario?.nmUsuario
            )
          }}
          valueName="value"
          maxLength={100}
        />
        <AutoCompleteInput
          noFilter
          name="nomeSubstituto"
          marginTop={SPACING.spacing5}
          onChangeText={useDebounce(handleSearchUsuario, 1000)}
          value={filterNomeSubstituto?.nomeSubstituto || null}
          options={autocomplete?.nomeSubstituto || []}
          optionValue="label"
          label="Substituto"
          onChange={(_, value) => {
            setFilterNomeSubstituto({
              nomeSubstituto: value?.usuario?.nmUsuario || ''
            })
            setMatriculaSubstituto({
              matriculaSubstituto: value?.nmMatricula || ''
            })
            handleCheckBox(
              'matriculaSubstituto',
              value?.nmMatricula,
              'noTable',
              'nomeSubstituto',
              value?.usuario?.nmUsuario
            )
          }}
          valueName="value"
          maxLength={100}
        />
      </Grid>

      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Col>
          <CheckBox
            onChange={() => {
              if (tabelaContraparte && tabelaContraparte.length > 0) {
                setMarcarTodosContraparte((prevState) => !prevState)
                handleCheckedAll(
                  'contrapartesIds',
                  'contrapartes',
                  tabelaContraparte
                )
              }
            }}
            checked={marcarTodosContraparte}
            label="Marcar Todos"
            marginBottom={SPACING.spacing10}
          />
          <div>
            <Card
              minHeight="300px"
              boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
              borderRadius="10px 10px"
            >
              <Line />
              <List
                itemCount={tabelaContraparte.length}
                estimatedItemSize={30}
                itemSize={(index: number) =>
                  getItemSize(contraparteSizeMap, index)
                }
                ref={contraparteListRef}
                height={300}
                width={'100%'}
                useIsScrolling
              >
                {({ index, style }) => (
                  <div key={tabelaContraparte[index].id} style={style}>
                    {
                      <ReportsRow
                        index={index}
                        windowWidth={windowWidth}
                        setSize={contraparteSetSize}
                      >
                        <CheckBox
                          checked={trueCheckbox.contrapartesIds.includes(
                            tabelaContraparte[index].id
                          )}
                          onChange={() => {
                            // setTrueCheckbox(prevState=> ({...prevState, contrapartesIds:[contraparte.id]}))
                            handleCheckBox(
                              'contrapartesIds',
                              tabelaContraparte[index].id,
                              'contraparte'
                            )
                          }}
                          label={tabelaContraparte[index].name}
                        />
                      </ReportsRow>
                    }
                  </div>
                )}
              </List>
            </Card>
          </div>
        </Col>
        <Col>
          <CheckBox
            onChange={() => {
              if (tabelaSubstituto && tabelaSubstituto.length > 0) {
                setMarcarTodosSubstituto((prevState) => !prevState)
                handleCheckedAll(
                  'substitutosIds',
                  'substitutos',
                  tabelaSubstituto
                )
              }
            }}
            checked={marcarTodosSubstituto}
            label="Marcar Todos"
          />
          <Card
            minHeight="300px"
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />
            <List
              itemCount={tabelaSubstituto.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(substitutoSizeMap, index)
              }
              ref={substitutoListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div key={tabelaSubstituto[index].id} style={style}>
                    {
                      <ReportsRow
                        index={index}
                        windowWidth={windowWidth}
                        setSize={substitutoSetSize}
                      >
                        <CheckBox
                          checked={trueCheckbox.substitutosIds.includes(
                            tabelaSubstituto[index].id
                          )}
                          onChange={() => {
                            // setTrueCheckbox(prevState=> ({...prevState, contrapartesIds:[contraparte.id]}))
                            handleCheckBox(
                              'substitutosIds',
                              tabelaSubstituto[index].id,
                              'substituto'
                            )
                          }}
                          label={tabelaSubstituto[index].name}
                        />
                      </ReportsRow>
                    }
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
      <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Input
          onChange={(e) => {
            setFornecedor({
              nomeFornecedor: e.target.value
            })
            const copyValue = trueCheckbox
            copyValue.nomeFornecedor = e.target.value
            setTrueCheckbox(copyValue)
          }}
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          value={filterFornecedor.nomeFornecedor}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => {
            // handleFilter(filterFornecedor, "noTable", true)
            // setFornecedor({
            //   nomeFornecedor: "",
            // })
            handleCheckBox(
              'nomeFornecedor',
              filterFornecedor.nomeFornecedor,
              'noTable'
            )
          }}
        />

        <Input
          onChange={(e) => {
            setEmpresa({
              nomeEmpresa: e.target.value
            })
            const copyValue = trueCheckbox
            copyValue.nomeEmpresa = e.target.value
            setTrueCheckbox(copyValue)
          }}
          label="Empresa"
          placeholder="Nome da Empresa"
          inputIcon={<MagnifyingGlassIcon />}
          value={filterEmpresa.nomeEmpresa}
          onClickIcon={() => {
            // handleFilter(filterEmpresa, "noTable", true)
            // setEmpresa({
            //   nomeEmpresa: "",
            // })
            handleCheckBox('nomeEmpresa', filterEmpresa.nomeEmpresa, 'noTable')
          }}
        />

        <Input
          onChange={(e) => {
            setCentro({
              nomeCentro: e.target.value
            })
            const copyValue = trueCheckbox
            copyValue.nomeCentro = e.target.value
            setTrueCheckbox(copyValue)
          }}
          label="Centro"
          placeholder="Nome do Centro"
          value={filterCentro.nomeCentro}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => {
            // handleFilter(filterCentro, "noTable", true)

            handleCheckBox('nomeCentro', filterCentro.nomeCentro, 'noTable')
            // setCentro({
            //   nomeCentro: "",
            // })
          }}
        />
      </Grid>
      <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Col>
          <CheckBox
            onChange={() => {
              if (tabelaFornecedor && tabelaFornecedor.length > 0) {
                setMarcarTodosFornecedor((prevState) => !prevState)
                handleCheckedAll(
                  'fornecedoresIds',
                  'fornecedores',
                  tabelaFornecedor
                )
              }
            }}
            checked={marcarTodosFornecedor}
            label="Marcar Todos"
            marginBottom={SPACING.spacing10}
          />
          <Card
            minHeight="300px"
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />
            <List
              itemCount={tabelaFornecedor.length}
              estimatedItemSize={50}
              itemSize={(index: number) =>
                getItemSize(fornecedorSizeMap, index)
              }
              ref={fornecedorListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div key={tabelaFornecedor[index].id} style={style}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={fornecedorSetSize}
                    >
                      <CheckBox
                        checked={trueCheckbox.fornecedoresIds.includes(
                          tabelaFornecedor[index].id
                        )}
                        onChange={() => {
                          // setTrueCheckbox(prevState=> ({...prevState, contrapartesIds:[contraparte.id]}))
                          handleCheckBox(
                            'fornecedoresIds',
                            tabelaFornecedor[index].id,
                            'fornecedor'
                          )
                        }}
                        label={tabelaFornecedor[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            onChange={() => {
              if (tabelaEmpresa && tabelaEmpresa.length > 0)
                setMarcarTodosEmpresa((prevState) => !prevState)
              handleCheckedAll('empresasIds', 'empresas', tabelaEmpresa)
            }}
            checked={marcarTodosEmpresa}
            label="Marcar Todos"
          />
          <Card
            minHeight="300px"
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />
            <List
              itemCount={tabelaEmpresa.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(empresaSizeMap, index)}
              ref={empresaListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div key={tabelaEmpresa[index].id} style={style}>
                    {
                      <ReportsRow
                        index={index}
                        windowWidth={windowWidth}
                        setSize={empresaSetSize}
                      >
                        <CheckBox
                          checked={trueCheckbox.empresasIds.includes(
                            tabelaEmpresa[index].id
                          )}
                          onChange={() => {
                            // setTrueCheckbox(prevState=> ({...prevState, contrapartesIds:[contraparte.id]}))
                            handleCheckBox(
                              'empresasIds',
                              tabelaEmpresa[index].id,
                              'empresa'
                            )
                          }}
                          label={tabelaEmpresa[index].name}
                        />
                      </ReportsRow>
                    }
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            onChange={() => {
              if (tabelaCentro && tabelaCentro.length > 0) {
                setMarcarTodosCentro((prevState) => !prevState)
                handleCheckedAll('centrosIds', 'centros', tabelaCentro)
              }
            }}
            checked={marcarTodosCentro}
            label="Marcar Todos"
          />
          <Card
            minHeight="300px"
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />
            <List
              itemCount={tabelaCentro.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(centroSizeMap, index)}
              ref={centroListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div key={tabelaCentro[index].id} style={style}>
                    {
                      <ReportsRow
                        index={index}
                        windowWidth={windowWidth}
                        setSize={centroSetSize}
                      >
                        <CheckBox
                          checked={trueCheckbox.centrosIds.includes(
                            tabelaCentro[index].id
                          )}
                          onChange={() => {
                            // setTrueCheckbox(prevState=> ({...prevState, contrapartesIds:[contraparte.id]}))
                            handleCheckBox(
                              'centrosIds',
                              tabelaCentro[index].id,
                              'centro'
                            )
                          }}
                          label={tabelaCentro[index].name}
                        />
                      </ReportsRow>
                    }
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
      <Grid gridCols="1fr 1fr " gridGap="1rem" margin="1rem 0 0 0">
        <Col>
          <Grid gridCols="1fr" gridGap="1rem" margin="1rem 0 0 0">
            <UnidadeGestoraFields
              ref={childRef}
              gridCols={{
                Diretoria: 6,
                DiretoriaExecutiva: 6,
                Gerencia: 6,
                GerenciaGeral: 6,
                spacing: 2
              }}
              onChange={(unidadeGestora: IOnChangeUnidadeGestora) => {
                setUnidadeGestoraID(unidadeGestora)
                !firstGetUnidade &&
                  handleCheckBox('unidadeGestoraId', unidadeGestora, 'noTable')
                setFirstGetUnidade(false)
              }}
            />
          </Grid>
          <Grid gridCols="1fr 1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
            <Col>
              <Text>Tipo</Text>
              <CheckBox
                onChange={() => {
                  handleCheckBox('tiposCreIds', 6, 'tiposCreIds')
                }}
                checked={tiposCreIds.includes(6) ? true : false}
                marginTop={SPACING.spacing20}
                label="Sazonal"
              />
            </Col>
            <CheckBox
              onChange={() => {
                handleCheckBox('tiposCreIds', 7, 'tiposCreIds')
              }}
              checked={tiposCreIds.includes(7) ? true : false}
              marginTop={SPACING.spacing30}
              label="Normal"
            />
            <CheckBox
              onChange={() => {
                handleCheckBox('tiposCreIds', 8, 'tiposCreIds')
              }}
              checked={tiposCreIds.includes(8) ? true : false}
              marginTop={SPACING.spacing30}
              label="Não se Aplica"
            />
            <CheckBox
              onChange={() => {
                handleCheckBox('tiposCreIds', 9, 'tiposCreIds')
              }}
              checked={tiposCreIds.includes(9) ? true : false}
              marginTop={SPACING.spacing30}
              label="Sem Preenchimento"
            />
            <Col>
              <Text>Tipo</Text>
              <CheckBox
                onChange={() => {
                  handleCheckFilters(
                    'flRecorrente',
                    filterRecorrente === true ? null : true,
                    'recorrente'
                  )
                  setFilterRecorrente((_) => filterRecorrente === true ? null : true)
                }}
                checked={filterRecorrente}
                marginTop={SPACING.spacing10}
                label="Recorrente"
              />
            </Col>
            <CheckBox
              onChange={() => {
                handleCheckFilters('flSocio', filterSocio === true ? null : true, 'socio')
                setFilterSocio((_) => filterSocio === true ? null : true)
              }}
              checked={filterSocio}
              marginTop={SPACING.spacing30}
              label="Sócio"
            />

            <CheckBox
              onChange={() => {
                handleCheckFilters('flEncerrado', filterEncerrado === true ? null : true, 'encerrado')
                setFilterEncerrado((_) => filterEncerrado === true ? null : true)
              }}
              checked={filterEncerrado}
              marginTop={SPACING.spacing30}
              label="Encerrado"
            />

          </Grid>
        </Col>
        <Col>
          <Input
            onChange={(e) => {
              setSubcontratada({
                nomeSubcontratada: e.target.value
              })
              const copyValue = trueCheckbox
              copyValue.nomeSubcontratada = e.target.value
              setTrueCheckbox(copyValue)
            }}
            label="Subcontratadas dos Fornecedores"
            placeholder="Nome da Subcontratada"
            inputIcon={<MagnifyingGlassIcon />}
            value={filterSubcontratada.nomeSubcontratada}
            onClickIcon={() => {
              handleCheckBox(
                'nomeSubcontratada',
                filterSubcontratada.nomeSubcontratada,
                'noTable'
              )
            }}
          />
          <CheckBox
            onChange={() => {
              if (tabelaSubcontratadas && tabelaSubcontratadas.length > 0) {
                setMarcarTodosSubcontratada((prevState) => !prevState)
                handleCheckedAll(
                  'subcontratadasIds',
                  'subcontratadas',
                  tabelaSubcontratadas
                )
              }
            }}
            checked={marcarTodosSubscotratada}
            label="Marcar Todos"
          />

          <Card
            minHeight="300px"
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />
            <List
              itemCount={tabelaSubcontratadas.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(subcontratadasSizeMap, index)
              }
              ref={subcontratadasListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div key={tabelaSubcontratadas[index].id} style={style}>
                    {
                      <ReportsRow
                        index={index}
                        windowWidth={windowWidth}
                        setSize={subcontratadasSetSize}
                      >
                        <CheckBox
                          checked={trueCheckbox.subcontratadasIds.includes(
                            tabelaSubcontratadas[index].id
                          )}
                          onChange={() => {
                            handleCheckBox(
                              'subcontratadasIds',
                              tabelaSubcontratadas[index].id,
                              'subcontratada'
                            )
                          }}
                          label={tabelaSubcontratadas[index].name}
                        />
                      </ReportsRow>
                    }
                  </div>
                </>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
      <Row
        marginTop={SPACING.spacing15}
        marginBottom={SPACING.spacing30}
        alignItems="center"
        justifyContent="end"
      >
        {/* <Button text="Voltar" variantButton="text" /> */}
        <Button
          onClick={async () => {
            await limparTudo()
            setTiposCreIds([])
            setTrueCheckbox((prevState) => ({ ...prevState, contrapartesIds: [] }))
          }}
          text="Limpar"
          variantButton="text"
          marginRight={SPACING.spacing15}
          marginLeft={SPACING.spacing15}
        />
        <Button onClick={handleViewReport} text="Visualizar" />
      </Row>
    </Card>
  )
}

export default ReportsCurrentContract
